import React, { useEffect } from "react";
import { useI18n } from "@/i18n";
import Header from "@/components/Header";
import Footer from "@/components/Footer";

export default function LegalPage({ tKey }) {
  const { t, raw, lang } = useI18n();

  useEffect(() => {
    document.title = t(`pageTitles.${tKey}`);
    document.documentElement.lang = lang === "en" ? "en" : "es";
  }, [t, tKey, lang]);

  const sections = raw[tKey].sections;

  return (
    <>
      <Header />
      <main className="legal-page">
        <div className="container">
          <header className="legal-head">
            <span className="eyebrow">Mirexilava</span>
            <h1>{t(`${tKey}.title`)}</h1>
            <p className="legal-updated">{t(`${tKey}.updated`)}</p>
            <p className="legal-intro">{t(`${tKey}.intro`)}</p>
          </header>
          <div className="legal-body">
            {sections.map((s, i) => (
              <section key={i} className="legal-section">
                <h2>{s.heading}</h2>
                <p>{s.body}</p>
              </section>
            ))}
          </div>
        </div>
      </main>
      <Footer />
    </>
  );
}
